/**
 * NEON — Traducción al español de las reseñas de Judge.me (oct 2026).
 *
 * Las 14 reseñas se importaron desde AliExpress vía Judge.me Importer y
 * llegaron en inglés — David pidió que se vean en español. El texto no
 * vive en el tema (vive en Judge.me, y se pinta por JavaScript de forma
 * PROGRESIVA, tarjeta a tarjeta, no todas de golpe — mismo comportamiento
 * ya documentado en assets/neon-resenas-autoplay.js), así que la forma
 * fiable de traducir es esta: en cuanto una tarjeta aparece en el DOM,
 * se busca su nombre de autor + texto original en el mapa de abajo y, si
 * hay traducción, se sustituye el cuerpo — sin tocar estrellas, nombre
 * ni fecha.
 *
 * NEON: intento inicial de emparejar por `data-review-id` DESCARTADO —
 * comprobado en el DOM real que pinta el widget (.jdgm-rev-snippet-card,
 * el carrusel que se usa aquí) que ese atributo NO existe ahí; solo
 * aparece en otro bloque HTML distinto que expone Judge.me
 * (.jdgm-rev, usado para otra cosa — no es el que se ve en esta página),
 * así que emparejar por ID no funcionaba en absoluto: ninguna tarjeta se
 * traducía. Se usa en su lugar NOMBRE DEL AUTOR + TEXTO ORIGINAL en
 * inglés como clave — combinación necesaria porque dos de las reseñas
 * duplicadas comparten el mismo texto exacto (ver más abajo), así que el
 * texto solo no basta para distinguir cuál tarjeta es cuál.
 *
 * Las 3 reseñas problemáticas (duplicadas/vacía, ver brief de calidad de
 * datos y el filtro correspondiente en neon-resenas-autoplay.js) NO
 * aparecen en este mapa a propósito — no hace falta traducir una copia
 * duplicada que no debería ni mostrarse (King Kris y Kelli Breitenberg,
 * duplicados exactos de Garrett Littel y Thurman Kub) ni una reseña sin
 * contenido real (Ellis Corkery). Quedan en inglés/sin tocar hasta que
 * David las oculte directamente desde el panel de Judge.me, que es la
 * solución definitiva (viven en su base de datos, no en el tema).
 *
 * Este script expone `window.neonTraducirTarjeta(tarjetaEl)` como
 * función reutilizable — neon-resenas-autoplay.js la llama también,
 * justo antes de clonar cada tarjeta para la cinta de móvil, como red de
 * seguridad adicional (por si esa cinta se construye antes de que el
 * observador de aquí abajo llegue a esa tarjeta en concreto). Llamarla
 * dos veces sobre la misma tarjeta no tiene ningún efecto raro — solo
 * vuelve a escribir el mismo texto ya traducido.
 *
 * A diferencia de neon-resenas-autoplay.js, este script NO se limita a
 * móvil ni depende del filtro de portada — debe traducir el carrusel
 * nativo de Judge.me en CUALQUIER pantalla (incluido el de escritorio,
 * que ese otro script ni toca en la ficha de producto normal).
 */
(function () {
  'use strict';

  var SELECTOR_TARJETA = '.jdgm-rev-snippet-card';
  var SELECTOR_CUERPO = '.jdgm-rev-snippet-card__body';
  var SELECTOR_NOMBRE = '.jdgm-rev-snippet-card__reviewer-name';

  function normalizar(texto) {
    return (texto || '').replace(/\s+/g, ' ').trim();
  }

  // Clave = "nombre del autor||texto original en inglés" (normalizados).
  var TRADUCCIONES = {};
  function registrar(nombre, textoOriginal, traduccion) {
    TRADUCCIONES[normalizar(nombre) + '||' + normalizar(textoOriginal)] = traduccion;
  }

  registrar(
    'Blossom Baumbach',
    "Well, it's great, just like the photos, it works perfectly without cables like others I've seen, it's comfortable. It makes a little noise when it's on, nothing that bothers with the murmur of people.",
    'Pues genial, tal cual las fotos, funciona perfecto sin cables como otras que he visto, es cómoda. Hace un poco de ruido cuando está encendida, nada que moleste con el bullicio de la gente.'
  );
  registrar(
    'Joaquina Shanahan',
    'Very nice. It works perfectly. But if you turn on the light there is an annoying noise.',
    'Muy chula. Funciona perfectamente. Pero si enciendes la luz hace un ruido un poco molesto.'
  );
  registrar(
    'Andre Moen',
    'Good halloween mask kids loved it',
    'Buena máscara de Halloween, a los niños les encantó.'
  );
  registrar(
    'Tracie Baumbach',
    'I loved it. A bit difficult to see when the lights are on in a dark environment.',
    'Me encantó. Cuesta un poco verse cuando las luces están encendidas en un sitio oscuro.'
  );
  registrar(
    'Thurman Kub',
    'The mask looked exactly as the pictures, works really well. The "hum" of electrical system can be heard in quiet rooms, but i dont think anybody would notice on party.',
    'La máscara es tal cual las fotos, funciona muy bien. Se nota un "zumbido" del sistema eléctrico en salas silenciosas, pero no creo que nadie lo note en una fiesta.'
  );
  registrar(
    'Leo Aufderhar',
    'Good mask grandson is very pleased',
    'Buena máscara, mi nieto está encantado.'
  );
  registrar(
    'Christena Cole',
    'Good product, the kids love it!',
    'Buen producto, ¡a los niños les encanta!'
  );
  registrar(
    'Noe Gulgowski',
    'Very good quality',
    'Muy buena calidad.'
  );
  registrar(
    "Lemuel O'Conner",
    "Fast delivery. Quality is okay, insert battery a bit difficult, but once insert it’s ok. Fits to the head due to the band",
    'Entrega rápida. La calidad está bien, meter la pila cuesta un poco, pero una vez puesta va perfecta. Se ajusta bien a la cabeza gracias a la cinta.'
  );
  registrar(
    'Ardell Kessler',
    "It's much better than in the photos, it gives quite a scare, I don't take photos because it loses quality, I highly recommend it.",
    'Es mucho mejor que en las fotos, da bastante miedo, no le hago fotos porque pierde calidad, la recomiendo totalmente.'
  );
  registrar(
    'Garrett Littel',
    'Great. Kids are happy!',
    '¡Genial! Los niños están felices.'
  );
  // King Kris (mismo texto que Garrett Littel) y Kelli Breitenberg (mismo
  // texto que Thurman Kub) quedan FUERA del mapa a propósito — ver el
  // comentario de cabecera. Ellis Corkery tampoco lleva entrada (sin
  // contenido real).

  var procesadas = {};

  // NEON: función reutilizable (ver comentario de cabecera) — también la
  // llama neon-resenas-autoplay.js antes de clonar cada tarjeta.
  window.neonTraducirTarjeta = function (tarjeta) {
    if (!tarjeta) return;
    var nombreEl = tarjeta.querySelector(SELECTOR_NOMBRE);
    var cuerpoEl = tarjeta.querySelector(SELECTOR_CUERPO);
    if (!nombreEl || !cuerpoEl) return;
    var clave = normalizar(nombreEl.textContent) + '||' + normalizar(cuerpoEl.textContent);
    var traduccion = TRADUCCIONES[clave];
    if (!traduccion) return;
    cuerpoEl.textContent = traduccion;
  };

  function traducirVisibles() {
    var tarjetas = document.querySelectorAll(SELECTOR_TARJETA);
    tarjetas.forEach(function (t, indice) {
      // NEON: sin un ID real en el DOM, se usa el índice de posición
      // como marca de "ya procesada" — basta con no re-procesar la
      // MISMA tarjeta (nodo del DOM) una segunda vez; distintas
      // tarjetas con el mismo nombre+texto (las duplicadas) se
      // procesan cada una por separado igualmente, sin problema, ya
      // que `neonTraducirTarjeta` simplemente no hace nada si esa
      // combinación nombre+texto no está en el mapa.
      if (t.dataset.neonTraducida) return;
      window.neonTraducirTarjeta(t);
      t.dataset.neonTraducida = '1';
    });
  }

  traducirVisibles();

  // Judge.me pinta sus tarjetas de forma progresiva (ver el mismo
  // razonamiento, ya documentado, en neon-resenas-autoplay.js) — se
  // sigue observando el DOM en vez de traducir solo una vez al cargar.
  var observador = new MutationObserver(traducirVisibles);
  observador.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () {
    observador.disconnect();
  }, 20000);
})();
